import React from 'react';
import InputField from './InputField';
import SubmitButton from './SubmitButton';
import UserStore from '../stores/UserStore';

class LoginForm extends React.Component {

  constructor(props){
    super(props);
    this.state ={
      username: '',
      password: '',
      buttonDisabled: false
    }
  }

  setInputValue(property, val){
    val = val.trim();

    this.setState({
      [property]: val
    })
  }

  resetForm(){
    this.setState({
      username: '',
      password: '',
      buttonDisabled: false
    })
  }

  saveUserStoreInSession() {


    sessionStorage.setItem('loginSession', JSON.stringify({
      "refresh_token": UserStore.refresh_token,
      "access_token": UserStore.access_token,
      "username": UserStore.username,
      "isLoggedIn": UserStore.isLoggedIn,
      "roles": UserStore.roles,
      "loading": UserStore.loading,
      "picture": UserStore.picture
    }));
  }

  async doLogin() {
    if (!this.state.username){
      return;
    }
    if (!this.state.password){
      return;
    }

    this.setState({
      buttonDisabled: true
    })

    try{
      console.log(process.env)
      let res = await fetch(global.apiUrl + '/oauth/token?client_id=api&grant_type=password&username=' + this.state.username +"&password="+this.state.password,{
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      });

      let result = await res.json();
      //console.log(result)
      //console.log(res)
      if (result && res.status === 200){
        UserStore.isLoggedIn = true;
        UserStore.access_token= result.access_token;
        UserStore.refresh_token= result.refresh_token;
        let role_res = await fetch(global.apiUrl + '/v0/users/me/roles?access_token=' + result.access_token,{
          method: 'get',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }});
        let role_res_json = await role_res.json();
        UserStore.roles = role_res_json;

        //console.log(role_res_json);
        let user_res = await fetch(global.apiUrl + '/v0/users/me?client_id=&access_token=' + result.access_token,{
          method: 'get',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }});
        let user_res_json = await user_res.json();
        UserStore.username = user_res_json.username;
        this.saveUserStoreInSession();


        // Move to logged in version of Residential registry
        if (window.location.pathname === '/') {
          window.location.pathname = '/bostadsregistret';
        }else{
          window.location.reload();
        }

      }else if (result && res.status !== 200){
        this.resetForm();
        alert(result.msg);
      }

    }catch(e){
      this.resetForm();
      //console.log(e);
    }

  }

  render() {
    return (
        <div className="loginForm">
          Log in
          <InputField
              type='text'
              placeholder='Username'
              value={this.state.username ? this.state.username : ''}
              onChange={ (val) => this.setInputValue('username', val)}
          />

          <InputField
              type='password'
              placeholder='Password'
              value={this.state.password ? this.state.password : ''}
              onChange={ (val) => this.setInputValue('password', val)}
          />

          <SubmitButton
              text='Login'
              disabled={this.state.buttonDisabled}
              onClick={ () => this.doLogin()}
          />
        </div>
    );
  }
}

export default LoginForm;
